import { Vector3, Vector3Tuple } from 'three';

import { CONSTANTS } from '@/config/constants';

export type Viewport = {
  width: number;
  height: number;
};

export function getCameraSettingsForBBox(
  aspect: Viewport,
  description: { center: Vector3 | Vector3Tuple; radius: number },
) {
  const { radius } = description;
  const { width, height } = aspect;
  const ratio = width / height;

  if (ratio >= 1) {
    return {
      zoom:
        (height / (radius * 2)) *
        CONSTANTS.scene.scaleFactor *
        CONSTANTS.camera.zoomFactor,
    };
  }

  return {
    zoom:
      (width / (radius * 2)) *
      CONSTANTS.scene.scaleFactor *
      CONSTANTS.camera.zoomFactor,
  };
}
